import asBentoPage from 'common/bento/hoc/asBentoPage';
import Card from 'components/_core/Card';
import Heading from 'components/_core/Heading';
import { VerificationStatus } from 'features/Onboarding/modules/Verification/lib/steps/types';

import { RichText } from '../../../Bento/atoms';
import { GetEpAgreementWallContextQuery } from '../../graphql/queries/getEpAgreementWallContext.gql';
import Bank from './assets/Bank.svg';
import PaperPenBlue from './assets/PaperPenBlue.svg';
import Siret from './assets/Siret.svg';
import HubStep from './components/HubStep';
import {
  getIsAgreementDone,
  getIsComplianceDone,
  getIsRegistrationDateDone,
  getSteps,
} from './helpers';
import locales from './locales';

interface IntroductionProps {
  moduleData: GetEpAgreementWallContextQuery;
  onAgreement: () => void;
  onCompliance: () => void;
  onRegistrationDate: () => void;
}

const Hub = asBentoPage<IntroductionProps>(
  ({ Layout, moduleData, onAgreement, onCompliance, onRegistrationDate }) => {
    const isAgreementDone = getIsAgreementDone(moduleData);
    const isComplianceDone = getIsComplianceDone(moduleData);
    const isRegistrationDateDone = getIsRegistrationDateDone(moduleData);
    const steps = getSteps(moduleData);

    return (
      <Layout>
        <Heading marginBottom="space-40" marginTop="space-48">
          {locales.title}
        </Heading>

        <RichText>
          {
            locales.formatString(
              steps.size > 1
                ? locales.description.plural
                : locales.description.singular,
              {
                totalSteps: steps.size,
              },
            ) as string
          }
        </RichText>

        <Card marginTop="space-16" padding="space-0">
          {steps.has('AGREEMENT') ? (
            <HubStep
              isDisabled={isAgreementDone}
              onClick={onAgreement}
              src={PaperPenBlue}
              status={
                isAgreementDone
                  ? VerificationStatus.Completed
                  : VerificationStatus.ToDo
              }
            >
              {locales.agreement}
            </HubStep>
          ) : null}

          {steps.has('COMPLIANCE') ? (
            <HubStep
              isDisabled={isComplianceDone}
              onClick={onCompliance}
              src={Bank}
              status={
                isComplianceDone
                  ? VerificationStatus.Completed
                  : VerificationStatus.ToDo
              }
            >
              {locales.compliance}
            </HubStep>
          ) : null}

          {steps.has('REGISTRATION_DATE') ? (
            <HubStep
              isDisabled={isRegistrationDateDone}
              onClick={onRegistrationDate}
              src={Siret}
              status={
                isRegistrationDateDone
                  ? VerificationStatus.Completed
                  : VerificationStatus.ToDo
              }
            >
              {locales.registrationDate}
            </HubStep>
          ) : null}
        </Card>
      </Layout>
    );
  },
);

export default Hub;
